import { LocalizedMatch } from "types/match"
import Link from "next/link"
import { getMatchPageUrlNew } from "../../../utils/urls"

function getResult(match: LocalizedMatch, teamId: number) {
  const homeScore = match.homeScore!
  const awayScore = match.awayScore!

  const home = match.homeTeamId === teamId

  if (home) {
    if (homeScore > awayScore) return "V"
    if (homeScore === awayScore) return "N"
    if (homeScore < awayScore) return "S"
  } else {
    if (awayScore > homeScore) return "V"
    if (awayScore === homeScore) return "N"
    if (awayScore < homeScore) return "S"
  }
}

export default function LastFiveMatchResult({
  matches,
  home,
  teamId,
}: {
  matches: LocalizedMatch[]
  home: boolean
  teamId: number
}) {
  let globalCssDiv = "last-five-match-result-div"
  if (home) {
    globalCssDiv += " last-five-match-result-home"
  }

  const matchesData = matches

  return (
    <div className={globalCssDiv}>
      {matchesData.length > 0 &&
        matchesData.map((match, index: number) => {
          let cssClassName = "single-match-result-div"

          const result = getResult(match, teamId)

          switch (result) {
            case "V":
              cssClassName += " single-match-result-div-win"
              break
            case "N":
              cssClassName += " single-match-result-div-draw"
              break
            case "S":
              cssClassName += " single-match-result-div-lose"
              break
          }

          return (
            <Link href={getMatchPageUrlNew(match)} key={index}>
              <a title={`${match.homeTeam?.name} ${match.homeScore} - ${match.awayScore} ${match.awayTeam?.name}`}>
                <div
                  className={cssClassName}
                  title={`${match.homeTeam?.name} ${match.homeScore} - ${match.awayScore} ${match.awayTeam?.name}`}
                >
                  <span className={"single-match-result"}>{result}</span>
                </div>
              </a>
            </Link>
          )
        })}
    </div>
  )
}
